

const displayAudioList: any = [];
const uploadAudioList: any = [];

export const EMSAudioService = {
  displayAudioList,
  uploadAudioList,
};
